import { render, staticRenderFns } from "./widget-activity.html?vue&type=template&id=1a6c479c&scoped=true&external"
import script from "./WidgetActivity.vue?vue&type=script&lang=js"
export * from "./WidgetActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6c479c",
  null
  
)

export default component.exports